import './index.scss'

// 表单点击提示文字上移
$('.form input').focus(function () {
  if (!$(this).parents('.form-item').hasClass('active')) {
      $(this).parents('.form-item').addClass('active')
  }
}).blur(function () {
  if ($(this).val() == '') {
      $(this).parents('.form-item').removeClass('active')
  }
})